"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NavigationArrows = void 0;
var _components = require("@ori-ui/components");
var _icons = require("@ori-ui/icons");
var _presentationHooks = require("@ori/presentation-hooks");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _esToolkit = require("es-toolkit");
var _get = _interopRequireDefault(require("es-toolkit/compat/get"));
var _react = require("react");
var _common = require("../../common");
var _carouselClasses = require("./carouselClasses");
var _styles = require("./styles");
var _utils = require("./utils");
var _jsxRuntime = require("react/jsx-runtime");
const NavigationArrows = ({
  instanceRef,
  lastSlideVisible,
  slider,
  slidesCount,
  navigation,
  pagination,
  useBreakpointsPerView,
  loading,
  mode = {
    type: 'sides'
  }
}) => {
  const {
    getTestId
  } = (0, _testidGenerator.default)();
  const [isAtTheEnd, setIsAtTheEnd] = (0, _react.useState)(false);
  const [isAtTheStart, setIsAtTheStart] = (0, _react.useState)(true);
  const [shouldHideArrowsOnInit, setShouldHideArrowsOnInit] = (0, _react.useState)(false);
  const {
    width
  } = (0, _presentationHooks.useWindowSize)();
  const currentSlide = (0, _get.default)(instanceRef, 'current.track.details.rel', 0);
  const createHandler = (0, _react.useCallback)(type => event => {
    event.stopPropagation();
    const index = (0, _utils.getIndex)({
      instanceRef,
      isAtTheEnd,
      isAtTheStart,
      setIsAtTheEnd,
      setIsAtTheStart,
      slider,
      slidesCount,
      type,
      viewportWidth: width,
      useBreakpointsPerView
    });
    instanceRef.current?.moveToIdx(index);
  }, [instanceRef, isAtTheEnd, isAtTheStart, slider, slidesCount, width, useBreakpointsPerView]);
  const onNextClick = createHandler('next');
  const onPreviousClick = createHandler('previous');
  const shouldShowPrevious = (0, _react.useMemo)(() => (0, _utils.shouldShowPreviousArrow)({
    currentSlide,
    slider
  }), [currentSlide, slider]);
  const shouldShowNext = (0, _react.useMemo)(() => (0, _utils.shouldShowNextArrow)({
    lastSlideVisible,
    slidesCount,
    currentSlide,
    slider
  }), [lastSlideVisible, slidesCount, currentSlide, slider]);
  (0, _react.useEffect)(() => {
    const debouncedSetArrowsVisibility = (0, _esToolkit.debounce)(() => {
      if (!loading) {
        setShouldHideArrowsOnInit(!shouldShowPrevious && !shouldShowNext);
      }
    }, 500);

    // We need to debounce the visibility check to avoid flickering because of animation delays
    debouncedSetArrowsVisibility();
    return () => {
      debouncedSetArrowsVisibility.cancel();
    };
  }, [loading, shouldShowPrevious, shouldShowNext]);
  if (mode.type === 'compact') {
    if (shouldHideArrowsOnInit) {
      return null;
    }
    return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.CompactButtonsContainer, {
      className: _carouselClasses.carouselClasses.compactButtonsRoot,
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_components.IconButton, {
        "aria-label": "\u2190",
        "data-testid": getTestId(_common.CAROUSEL_PREVIOUS_ARROW),
        variant: "contained",
        color: "secondary",
        disabled: !shouldShowPrevious,
        onClick: onPreviousClick,
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_icons.ArrowLeftThin, {})
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_components.IconButton, {
        "aria-label": "\u2192",
        "data-testid": getTestId(_common.CAROUSEL_NEXT_ARROW),
        variant: "contained",
        color: "secondary",
        disabled: !shouldShowNext,
        onClick: onNextClick,
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_icons.ArrowRightThin, {})
      })]
    });
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [shouldShowPrevious ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.PreviousArrow, {
      "aria-label": "\u2190",
      "data-testid": getTestId(_common.CAROUSEL_PREVIOUS_ARROW),
      height: navigation?.height,
      position: pagination?.position,
      role: "button",
      size: navigation?.size,
      onClick: onPreviousClick,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_icons.ArrowLeftThin, {})
    }) : null, shouldShowNext ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.NextArrow, {
      "aria-label": "\u2192",
      "data-testid": getTestId(_common.CAROUSEL_NEXT_ARROW),
      height: navigation?.height,
      position: pagination?.position,
      role: "button",
      size: navigation?.size,
      onClick: onNextClick,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_icons.ArrowRightThin, {})
    }) : null]
  });
};
exports.NavigationArrows = NavigationArrows;
//# sourceMappingURL=NavigationArrows.js.map